<template>
  <div class="containerTable" style="padding:15px;">
    <vxe-toolbar
      id="toolbarId_as6"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('cardBalance_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('cardBalance_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      show-footer
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      :loading="loading"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="name" title="姓名" min-width="100" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="phone" title="电话" min-width="130" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="cardNo"
          title="油卡编号"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.cardNo"
            placeholder="请输入油卡编号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="cardBalance"
          title="油卡余额"
          min-width="150"
        />
      </vxe-table-column>

      <vxe-table-column title="操作" min-width="160" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('cardBalance_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(scope.row)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="1000"
      height="600"
      resize
    >
      <compDetail ref="detailRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compDetail from "./components/cardTransactionList.vue";
import request from "@/utils/request";
export default {
  name: "CardBalanceList",
  components: {
    compDetail
  },
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      transTimeRange: [],
      modelDetailFlag: false,
      copy: false,
      exportObj: {
        exportUrl: "/ntocc-tps-api/zhaoYou/exportCard", //导出接口
        name: "油卡余额"
      },
      listQuery: {
        branchCode: "",
        name: "",
        phone: "",
        cardNo: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
    };
  },
  computed: {
    branchList() {
      return this.$store.state.components.branchList;
    }
  },
  watch: {
    "$store.state.components.branchList": function() {
      this.$refs.xTable.updateData();
    }
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-tps-api/zhaoYou/cardList",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },

    // 详情方法
    funcDetail(params) {
      this.$refs.detailRef.getInfo(params);
      this.modelDetailFlag = true;
    },
    // 公共取消
    fatherCancel(modelFlag) {
      if (modelFlag == "detail") {
        this.modelDetailFlag = false;
      }
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>
<style></style>
